import PreviewElement from '../PreviewElement';

export default class NavigationElement extends PreviewElement {
  injectSessionData(page): void {
    page.navigations.push({
      name: this.element.content.metaInfo.name,
      version: this.element.content.content.version
    });
  }
}
